export default {
  state: {
    modalActive: false,
    modalComponent: null
  },
  getters: {
    modalActive: state => state.modalActive,
    modalComponent: state => state.modalComponent
  },
  mutations: {
    showModal(state, componentName) {
      state.modalActive = true;
      state.modalComponent = componentName;
    },
    hideModal(state) {
      state.modalActive = false;
    }
  },
  actions: {
    showLoadingModal({ commit }, isLoading) {
      if (isLoading) {
        commit("showModal", "LoadingModal");
      } else {
        commit("hideModal");
      }
    }
  }
};
